// @ts-nocheck

import React, { useEffect, useState } from "react";
import SoftBox from "../../../components/common/softBox";
import SoftTypography from "../../../components/common/softTypography";
import SoftInput from "../../../components/common/softInput";
import SoftButton from "../../../components/common/softButton";
import { useDispatch, useSelector } from "react-redux";
import {
  editCreditSegmentCode,
  getCreditSegmentCodeById,
} from "../../../features/creditSegmentCode";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import DashboardNavbar from "../../../components/navbars/dashboardNavbar";

const EditCreditSegmentCode = () => {
  const { id } = useParams<{ id: string }>();
  const { creditSegmentCode, status } = useSelector(
    (state: any) => state.creditSegmentCode
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    id: id,
    key: "",
    value: "",
  });

  useEffect(() => {
    dispatch(getCreditSegmentCodeById(id));
  }, [dispatch, id]);

  useEffect(() => {
    if (status && creditSegmentCode?.data) {
      const data = creditSegmentCode.data;
      setFormData({
        id: data._id,
        key: data.key,
        value: data.value,
      });
    }
  }, [status, creditSegmentCode]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = () => {
    dispatch(editCreditSegmentCode({ id, updatedCreditSegmentCode: formData }))
      .then((resultAction) => {
        if (editCreditSegmentCode.rejected.match(resultAction)) {
          console.error(resultAction.payload || resultAction.error);
        } else {
          toast.success("Credit Segment Code updated successfully.");
          navigate("/credit-segments");
        }
      })
      .catch((err) => {
        console.error(err, "error");
        toast.error("Failed to update Credit Segment Code.");
      });
  };

  return (
    <SoftBox className="language-box">
      <DashboardNavbar />

      <SoftBox>
        <SoftBox mb={2}>
          <SoftTypography variant="h4" fontWeight="bold" textAlign="left">
            Edit Credit Segment Code
          </SoftTypography>
        </SoftBox>
        <SoftBox component="form" role="form">
          {/* Key Input */}
          <SoftBox sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}>
            <SoftBox sx={{
                width: {
                  sm: "100%",
                  md: "48%",
                },
              }}>
              <SoftTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Key
              </SoftTypography>
              <SoftInput
                type="text"
                name="key"
                placeholder="Enter key"
                value={formData.key}
                onChange={handleChange}
              />
            </SoftBox>

            {/* Value Input */}
            <SoftBox sx={{
                width: {
                  sm: "100%",
                  md: "48%",
                },
              }}>
              <SoftTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Value
              </SoftTypography>
              <SoftInput
                type="text"
                name="value"
                placeholder="Enter value"
                value={formData.value}
                onChange={handleChange}
              />
            </SoftBox>
          </SoftBox>

          {/* Submit Button */}
          <SoftBox mt={4} mb={1}>
            <SoftButton
              variant="gradient"
              color="final"
              fullWidth
              onClick={handleSubmit}
            >
              Submit
            </SoftButton>
          </SoftBox>
        </SoftBox>
      </SoftBox>
    </SoftBox>
  );
};

export default EditCreditSegmentCode;
